import { gql } from '@apollo/client';

/**
 * PC 包牌页 PPMOD 容器候选（bag_container 字典表启用中）。
 * 用于筛选下拉 + 行级容器编辑下拉；数据量 ≤ 10，可缓存。
 */
export const LIST_ACTIVE_BAG_CONTAINERS = gql`
    query ListActiveBagContainers($operateType: Int!) {
        listActiveBagContainers(operateType: $operateType) {
            id
            code
            name
        }
    }
`;

export interface BagContainerCandidate {
    id: number;
    code: number;
    name: string;
}

export interface ListActiveBagContainersResponse {
    listActiveBagContainers: BagContainerCandidate[];
}

/** 与后端 `BagContainerOperateType` 对齐：TT=1 / TEMU=2 */
export enum BagContainerOperateType {
    TT = 1,
    TEMU = 2,
}
